module.exports = __webpack_public_path__ + "static/media/marshall.4ed6e528.jpg";